import {
  CButton,
  CButtonGroup,
  CCol,
  CFormGroup,
  CInput,
  CLabel,
  CRow,
  CSelect,
} from "@coreui/react";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { createItem, updateItem, ItemRequestStatus } from "../../api/generics";
import Errors, { getFieldErrors } from "../../models/errors";
import { SUCCESS } from "../../utils/constants/tags";
import { FieldErrors } from "../form/FieldErrors";
import { errorAlert } from "../utils/messages";
import { emptyValueOnUndefined } from "../../utils/fields";
import { RootState } from "../../store";
import { useSelector } from "react-redux";
import Category, { newCategory } from "../../models/category";

interface CategoryFormProps {
  initialCategory?: Category;
  initialErrors?: Errors;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const CategoryForm: React.FC<CategoryFormProps> = ({
  initialCategory,
  initialErrors,
  onCancel,
  onSuccess,
}) => {
  const company = useSelector((state: RootState) => state.company.data.company);
  const [editingCategory, setEditingCategory] = useState<Category>(
    initialCategory ? initialCategory : newCategory()
  );

  const [errors, setErrors] = useState<Errors>(
    initialErrors ? initialErrors : {}
  );
  const [submitting, setSubmitting] = useState(false);

  const onNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditingCategory({
      ...editingCategory,
      name: e.target.value,
    });
  };

  const onOwnerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditingCategory({
      ...editingCategory,
      categoryOwner: e.target.value,
    });
  };

  const onSave = async () => {
    setSubmitting(true);
    let toSendCategory = {
      ...editingCategory,
      companyId: company.id,
    };
    let requestPromise: Promise<ItemRequestStatus<Category>>;
    if (editingCategory.id === undefined) {
      requestPromise = createItem<Category>(
        "/categories/create/",
        toSendCategory
      );
    } else {
      requestPromise = updateItem<Category>(
        `/categories/${toSendCategory.id}/`,
        toSendCategory
      );
    }

    const categoryStatus = await requestPromise;

    if (categoryStatus.status !== SUCCESS) {
      if (categoryStatus.errors !== undefined) {
        setErrors(categoryStatus.errors);
      }

      let message = "Ha ocurrido un error!!";
      if (categoryStatus.detail !== undefined) {
        message = categoryStatus.detail;
      }
      errorAlert(message);
    } else {
      setErrors({});
      clearForm();
      onSuccess();
    }
    setSubmitting(false);
  };

  const onClose = () => {
    clearForm();
    onCancel();
  };

  const clearForm = () => {
    setEditingCategory(newCategory());
  };

  useEffect(() => {
    setEditingCategory(initialCategory ? initialCategory : newCategory());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialCategory]);

  useEffect(() => {
    setErrors(initialErrors ? initialErrors : {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialErrors]);

  return (
    <>
      <fieldset disabled={submitting}>
        <CFormGroup>
          <CRow>
            <CCol md={2}>
              <CLabel>Nombre:</CLabel>
            </CCol>
            <CCol>
              <CInput
                type="text"
                value={emptyValueOnUndefined(editingCategory.name)}
                onChange={onNameChange}
                placeholder="Nombre"
              ></CInput>
              <FieldErrors
                errors={getFieldErrors("name", errors) as string[]}
              ></FieldErrors>
            </CCol>
          </CRow>
        </CFormGroup>
        <CFormGroup>
          <CRow>
            <CCol md={2}>
              <CLabel>Dueño de categoría:</CLabel>
            </CCol>
            <CCol>
              <CSelect
                type="text"
                onChange={onOwnerChange}
                value={
                  editingCategory.categoryOwner
                    ? editingCategory.categoryOwner
                    : ""
                }
              >
                <option value={""}>-----</option>
                <option value={"donna"}>DONNA</option>
                <option value={"jeans"}>JEANS</option>
                <option value={"international"}>Internacional</option>
                <option value={"rigido"}>Rígido</option>
              </CSelect>
              <FieldErrors
                errors={getFieldErrors("categoryOwner", errors) as string[]}
              ></FieldErrors>
            </CCol>
          </CRow>
        </CFormGroup>
        <CFormGroup className="float-right">
          <CButtonGroup>
            <CButton type="button" color="secondary" onClick={onClose}>
              Atras
            </CButton>
            <CButton type="submit" color="primary" onClick={onSave}>
              {submitting ? (
                <Spinner
                  animation="grow"
                  style={{
                    height: "17px",
                    width: "17px",
                    marginTop: "auto",
                    marginBottom: "auto",
                    marginRight: "10px",
                  }}
                />
              ) : (
                <></>
              )}
              {submitting ? "Guardando..." : "Guardar"}
            </CButton>
          </CButtonGroup>
        </CFormGroup>
      </fieldset>
    </>
  );
};

export default CategoryForm;
